import styled from "@emotion/styled";
import type { FC } from "react";

import { MDSText, MDSTextColor, MDSTextVariant } from "@/mds";

type Stats = {
  artifactStateLabel: string;
  totalDurationLabel: string;
  totalSizeLabel: string;
  unitCount: number;
  unitLabel: string;
};

type Props = {
  isLoading: boolean;
  stats: Stats | null;
};

export const InfoHeader: FC<Props> = ({ isLoading, stats }) => (
  <HeaderContainer>
    <MDSText variant={MDSTextVariant.HeaderS}>Info</MDSText>
    {!isLoading && stats && (
      <StatusBadge variant={MDSTextVariant.TextXs} color={MDSTextColor.Secondary}>
        State: {stats.artifactStateLabel} · Duration: {stats.totalDurationLabel} · Size:{" "}
        {stats.totalSizeLabel} · {stats.unitLabel}: {stats.unitCount}
      </StatusBadge>
    )}
  </HeaderContainer>
);

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.75rem;
`;

const StatusBadge = styled(MDSText)`
  padding: 0.25rem 0.75rem;
  border-radius: 999px;
  background-color: ${({ theme }) => theme.colors.background.badge.default};
`;
